import GATSBY_COMPILED_MDX from "/Users/jerry/Code/Jerrytron/jerrytron-com/src/projects/polite-dinner-extreme.md";
import React from 'react';
import Slider from 'react-slick';
import {graphql} from 'gatsby';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import {MDXProvider} from '@mdx-js/react';
import Layout from '../components/layout';
import {buildMdxImages} from '../components/images';
const Project = ({data, children}) => {
  const project = data.mdx;
  const frontmatter = project.frontmatter;
  const fields = project.fields;
  const thumbnail = getImage(fields.thumbnail?.childImageSharp);
  const slides = fields.slides;
  const credits = frontmatter.credits;
  const recognition = frontmatter.recognition;
  const gallery = fields.gallery;
  const components = buildMdxImages(fields.images);
  return React.createElement(Layout, null, React.createElement("article", {
    className: "sheet"
  }, React.createElement("div", {
    className: "sheet__inner"
  }, thumbnail && React.createElement("div", {
    className: "sheet__banner"
  }, React.createElement(GatsbyImage, {
    image: thumbnail,
    alt: frontmatter.title || ''
  })), React.createElement("h1", {
    className: "sheet__title"
  }, frontmatter.title), React.createElement("div", {
    className: "sheet__lead"
  }, frontmatter.summary), React.createElement("hr"), React.createElement(QuickLinks, {
    credits: credits,
    recognition: recognition,
    gallery: gallery
  }), React.createElement(SliderGallery, {
    slides: slides,
    title: frontmatter.title
  }), React.createElement("div", {
    className: "sheet__body"
  }, React.createElement(MDXProvider, {
    components: components
  }, children)), React.createElement(Credits, {
    credits: credits
  }), React.createElement(Recognition, {
    recognition: recognition
  }), React.createElement(Gallery, {
    images: gallery,
    title: frontmatter.title
  }))));
};
function QuickLinks({credits, recognition, gallery}) {
  if (!credits && !recognition && !gallery) {
    return null;
  }
  return React.createElement("div", null, React.createElement("p", {
    className: "sheet__quicklinks"
  }, " • ", credits && React.createElement("span", null, React.createElement("a", {
    href: "#credits"
  }, "Credits"), " • "), recognition && React.createElement("span", null, React.createElement("a", {
    href: "#recognition"
  }, "Recognition"), " • "), gallery && React.createElement("span", null, React.createElement("a", {
    href: "#gallery"
  }, "Gallery"), " • ")), React.createElement("hr"));
}
function SliderGallery({slides, title}) {
  if (!slides || slides.length === 0) {
    return null;
  }
  return React.createElement("div", {
    className: "sheet__slider"
  }, React.createElement(Slider, {
    slidesToShow: 2,
    infinite: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 6000
  }, slides.map((slide, i) => {
    const image = getImage(slide?.childImageSharp);
    return image ? React.createElement(GatsbyImage, {
      key: i,
      image: image,
      alt: `${title || ''} slide ${i + 1}`
    }) : React.createElement("div", {
      key: i
    });
  })));
}
function Credits({credits}) {
  if (!credits) {
    return null;
  }
  return React.createElement("div", {
    className: "sheet__body"
  }, React.createElement("h2", {
    id: "credits"
  }, "Credits"), React.createElement("ul", null, credits.map((credit, i) => React.createElement("li", {
    key: i
  }, credit.link ? React.createElement("span", null, React.createElement("a", {
    href: credit.link
  }, credit.name), " – ", credit.role) : React.createElement("span", null, credit.name, " – ", credit.role)))));
}
function Recognition({recognition}) {
  if (!recognition) {
    return null;
  }
  return React.createElement("div", {
    className: "sheet__body"
  }, React.createElement("h2", {
    id: "recognition"
  }, "Recognition"), React.createElement("ol", {
    className: "sheet__recognition"
  }, recognition.map((item, i) => React.createElement("li", {
    className: "sheet__recognitionitem",
    key: i
  }, React.createElement("strong", null, item.event), React.createElement("em", null, item.status), item.location, " — ", item.datesPretty))));
}
function Gallery({images, title}) {
  if (!images || images.length === 0) {
    return null;
  }
  return React.createElement("div", {
    className: "sheet__body"
  }, React.createElement("h2", {
    id: "gallery"
  }, "Gallery"), React.createElement("div", {
    className: "sheet__gallery"
  }, images.map((item, i) => {
    const image = getImage(item?.childImageSharp);
    return image ? React.createElement(GatsbyImage, {
      className: "sheet__galleryimage",
      key: i,
      image: image,
      alt: `${title || ''} gallery image ${i + 1}`
    }) : null;
  })));
}
export const query = graphql`
   query ($id: String!) {
      mdx(id: { eq: $id }) {
         frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
            summary
            credits {
               name
               link
               role
            }
            recognition {
               event
               status
               location
               dates
               datesPretty
               link
               award
               detail
            }
         }
         fields {
            thumbnail {
               childImageSharp {
                  gatsbyImageData(
                     width: 600
                     height: 250
                     transformOptions: { cropFocus: CENTER }
                     layout: CONSTRAINED
                  )
               }
            }
            slideCount
            slides {
               childImageSharp {
                  gatsbyImageData(
                     width: 200
                     height: 150
                     transformOptions: { cropFocus: ATTENTION }
                     layout: CONSTRAINED
                  )
               }
            }
            imageCount
            images {
               publicURL
               childImageSharp {
                  gatsbyImageData(width: 600, layout: CONSTRAINED)
               }
            }
            galleryCount
            gallery {
               childImageSharp {
                  gatsbyImageData(width: 600, layout: CONSTRAINED)
               }
            }
         }
         excerpt
      }
   }
`;
Project
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Project, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
